import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { initStore } from 'store/store';
import { http } from './helpers/http';
import { v4 as uuidv4 } from 'uuid';
import App from './App';
import './index.scss';
import axios from 'axios';
import { registerMaintenanceModeInterceptor } from '@urbanx/agx.auth.client';

registerMaintenanceModeInterceptor(axios, import.meta.env.BASE_URL);

// Store a session ID to be passed to the APIs as an x-session-id header.
sessionStorage.setItem(http.sessionName, uuidv4());

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

const store = initStore();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
